import { Injectable } from '@angular/core';
import { ISignatureFormDataService } from '../../../interfaces/isignatureproviderservice';

@Injectable({
  providedIn: 'root',
})
export class DocusignFormDataService implements ISignatureFormDataService {
  providerName = 'docusign';

  buildSignatureTabLabelPath(docusignTabLabel: string): string {
    // [(${docusign.formData.items.xxx)})]
    return `${this.providerName}.formData.${docusignTabLabel}`;
  }

  getSignatureTabLabel(path: string): string {
    // path to key value pairs of data from the signed document
    // docusign.formData.items.xxx
    if (!path.length) {
      return '';
    }

    const pathParts: string[] = path.toString().split('.');
    return pathParts[pathParts.length - 1];
  }
}
